export enum PRO_SIGNUP_STEPS {
	STEP_ONE = 'step 1: create account',
	STEP_TWO = 'step 2: contact information',
	STEP_THREE = 'step 3: company details'
}
